import React, { useState } from "react";
import { View, ScrollView, TouchableHighlight, StyleSheet } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import {
  ParkingArea,
  ParkingLot,
  ReserveModel,
} from "../viewModels/SmartParking";
import PersianCalendar from "../components/PersianCalendar";
import SimpleTimePicker from "../components_v2/SimpleTimePicker";
import axios from "axios";
import Loading from "../components/Loading";
let moment = require("moment-jalaali");
import useFilterItem from "../hooks/filterItem";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import InputBase from "../nativeBase-ui/InputBase";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
const HIDE_RESEND_SMS = 5 * 60 * 1000; // 5 min
const HIDE_MESSAGE_ERROR = 6 * 1000; // 6 s
const ParkingReservationFormScreen = (props: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [parkingArea, setParkingArea] = useState<ParkingArea | any>(
    props.navigation.state.params.parkingArea
  );
  const [availableLotsList, setAvailableLotsList] = useState([]);
  const reservedData =
    props.navigation.state.params.reservedData &&
    props.navigation.state.params.reservedData;

  const [reserveData, setReserveData] = useState<ReserveModel>({
    phoneNumber: reservedData?.phoneNumber || "",
    date: reservedData?.date || new Date().toISOString(), // "2022-08-28T12:51:41.804Z"
    startTime: reservedData?.startTime || "",
    endTime: reservedData?.endTime || "",
    buildingId: props.appReducer.currentBuilding.buildingId,
    smartParkingId: parkingArea.smartParkingId,
    parkingAreaId: parkingArea.id,
    parkingLotId: reservedData?.parkingLotId || null,
    fullName: reservedData?.fullName || "",
    // scenarioId: null,
  });

  // === Jalaali Date ===
  const [dateJalaali, setDatejalaali] = useState<string>(
    moment(reserveData.date).format("jYYYY/jM/jD")
  );
  const nowTimeHour =
    new Date().getHours() < 10
      ? "0" + new Date().getHours()
      : new Date().getHours();
  const twoHourNowTime =
    new Date().getHours() < 10
      ? Number("0" + new Date().getHours()) + 2
      : new Date().getHours() + 2;
  const nowTimeMin =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  // === Filter availableLots ===
  // const availableLotsFilter = smartParking?.parkingLots.filter(
  //   (item: ParkingLot) => {
  //     return item.status == "Available";
  //   }
  // );

  // === Modal ===
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  // const [isModalVisibleNewReserve, setIsModalVisibleNewReserve] = useState<boolean>(false);
  useState<boolean>(false);
  // === Select Parking  for reseve ===

  const reservedParkingLotName = parkingArea.parkingLots.find((i: any) => {
    return i.id === reservedData?.parkingLotId;
  });
  const [selectParkingLot, setSelectParkingLot] = useState<string | null>(
    reservedParkingLotName?.name
  );
  const [showConfirmMessage, setShowConfirmationMessage] = useState(false);
  // === Error Message ==
  const [reserveId, setReserveId] = useState("");
  const [errorFullName, setErrorFullName] = useState("");
  const [errorMessagePhone, setErrorMessagePhone] = useState("");
  const [errorMessageTimer, setErrorMessageTimer] = useState("");
  // === Http Requset Handler ===
  const serverUrl = props.appReducer.serverUrl;
  const accessToken = props.appReducer?.currentServer.accessToken;
  const [resultReserveMessage, setResultReserveMessage] = useState<string[]>(
    []
  );
  const [reserveStatus, setReserveStatus] = useState<boolean>(false);
  const newReserveRequest = (
    serverUrl: string,
    accessToken: string,
    body: ReserveModel
  ) => {
    if (!serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    axios
      .post(`${serverUrl}SmartParking/NewReserve`, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setReserveId(response.data.id);
        setIsLoading(false);
        setIsModalVisible(false);
        setShowConfirmationMessage(true);
        setShowParingLotsList(false);
        setReserveStatus(response.data.successful);
        setResultReserveMessage(response.data.errors);
      })
      .catch((error) => {
        setIsLoading(false);
        setShowConfirmationMessage(true);
        console.log(error);
      });
  };
  const getAvailableLotsRequest = (serverUrl: string, accessToken: string) => {
    if (!serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    const filterUndefined = (time: any, status?: string) => {
      var result = time;
      var filterUndefined = time.split(":");
      // Hour
      if (filterUndefined[0] == "undefined") {
        filterUndefined[0] =
          status === "endTime" ? `${twoHourNowTime}` : `${nowTimeHour}`;
        result = `${filterUndefined[0]}:${filterUndefined[1]}`;
      }
      // Min
      if (filterUndefined[1] == "undefined") {
        filterUndefined[1] = `${nowTimeMin}`;
        result = `${filterUndefined[0]}:${filterUndefined[1]}`;
      }
      return result;
    };
    const availableLots = {
      date: new Date(reserveData.date).toISOString(), // "2022-08-28T12:51:41.804Z"
      start:
        (reserveData.startTime !== ":" &&
          filterUndefined(reserveData?.startTime)) ||
        `${nowTimeHour}:${nowTimeMin}`,
      end:
        (reserveData.endTime !== ":" &&
          filterUndefined(reserveData?.endTime, "endTime")) ||
        `${twoHourNowTime}:${nowTimeMin}`,
      parkingAreaId: parkingArea.id,
    };
    setReserveData({
      ...reserveData,
      startTime:
        (reserveData.startTime !== ":" &&
          filterUndefined(reserveData?.startTime)) ||
        `${nowTimeHour}:${nowTimeMin}`,
      endTime:
        (reserveData.endTime !== ":" &&
          filterUndefined(reserveData?.endTime, "endTime")) ||
        `${twoHourNowTime}:${nowTimeMin}`,
    });

    axios
      .get(
        `${serverUrl}SmartParking/AvailableLots?parkingAreaId=${availableLots.parkingAreaId}&date=${availableLots.date}&start=${availableLots.start}&end=${availableLots.end}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setAvailableLotsList(res.data);
          setShowParingLotsList(true);
          setIsLoading(false);
          // console.log(res);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("availableLots Error :", error);
      });
  };
  // === resend Sms ===
  const [showModalResendSms, setShowModalResendSms] = useState(false);
  const [messageResendSms, setMessageResendSms] = useState("");
  const [hideResendSms, setHideResendSms] = useState(true);
  const resendSmsRequest = (serverUrl: string, reserveId: string) => {
    if (serverUrl && !serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    axios
      .get(`${serverUrl}SmartParking/SendInvitationLink/${reserveId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowModalResendSms(false);
        setHideResendSms(false);
        setMessageResendSms(translate("app.successResendSms"));
        setInterval(() => {
          setMessageResendSms("");
        }, HIDE_MESSAGE_ERROR);
        setInterval(() => {
          setHideResendSms(true);
        }, HIDE_RESEND_SMS);
        // response.status == 200
        // console.log(response);
      })
      .catch((error) => {
        console.log("error delete reserve", error);
        setShowModalResendSms(false);
        setMessageResendSms(translate("app.failedResendSms"));
        setInterval(() => {
          setMessageResendSms("");
        }, HIDE_MESSAGE_ERROR);
      });
  };
  const resendSmsHandler = (reserveId: string) => {
    resendSmsRequest(serverUrl, reserveId);
  };
  // === inputSearch useState ===
  const [inputSearchParkingList, setInputSearchParkingList] =
    useState<string>("");
  // === filter hook ===
  const [filterParkingLotList] = useFilterItem(
    inputSearchParkingList,
    availableLotsList,
    "name"
  );
  const [showParkingLotsList, setShowParingLotsList] = useState(
    props.navigation.state.params.showParkingReserved || false
  );
  const accessTime = () => {
    var result = true;

    var time = {
      startTime: reserveData.startTime,
      endTime: reserveData.endTime,
    };
    if (time.endTime == ":") {
      time.endTime = `${twoHourNowTime}:${nowTimeMin}`;
    }
    if (time.startTime == ":") {
      time.startTime = `${nowTimeHour}:${nowTimeMin}`;
    }
    if (time.endTime == ":" && time.endTime == ":") {
      time = {
        startTime: `${nowTimeHour}:${nowTimeMin}`,
        endTime: `${twoHourNowTime}:${nowTimeMin}`,
      };
    }
    if (time.startTime !== "" && time.endTime == "") {
      time.endTime = `${twoHourNowTime}:${nowTimeMin}` || reserveData.endTime;
    } else if (time.startTime == "" && time.endTime !== "") {
      time.startTime = reserveData.startTime || `${nowTimeHour}:${nowTimeMin}`;
    } else if (time.startTime == "" && time.endTime == "") {
      time = {
        startTime: reserveData.startTime || `${nowTimeHour}:${nowTimeMin}`,
        endTime: reserveData.endTime || `${twoHourNowTime}:${nowTimeMin}`,
      };
    }
    if (time.startTime !== "" || time.endTime !== "") {
      if (
        new Date().toDateString() == new Date(reserveData.date).toDateString()
      ) {
        if (time.endTime > `${nowTimeHour}:${nowTimeMin}` == false) {
          result = false;
        }
      } else {
        if (time.endTime < time.startTime) {
          result = false;
        }
      }
    }
    return result;
  };
  const CheckInfoCard = () => {
    return (
      <View style={{ padding: 12, marginBottom: 5 }}>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.fullNameGuest")} :{" "}
          {reserveData.fullName}
        </Text>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.phoneNumber")} :{" "}
          {reserveData.phoneNumber}
        </Text>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.dateReserve")} : {dateJalaali}
        </Text>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.startTime")} :{" "}
          {reserveData.startTime}
        </Text>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.endTime")} :{" "}
          {reserveData.endTime}
        </Text>
        <Text style={styles.txt}>
          {translate("smartParking.reservation.parking")} : {selectParkingLot}
        </Text>
      </View>
    );
  };
  const checkJustFailedToSmsError =
    resultReserveMessage.includes("FailedToSendSms") &&
    resultReserveMessage.length == 1;
  console.log("accessTime", accessTime);
  return parkingArea.length == 0 ? (
    <Loading />
  ) : isLoading ? (
    <Loading />
  ) : showParkingLotsList ? (
    // === ParkingList Based on date & End & start time
    <View
      style={{
        backgroundColor: Theme.COLORS.WHITE,
        borderRadius: 5,
        height: "90%",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          height: 45,
          marginHorizontal: 15,
          marginVertical: 15,
          marginBottom: 15,
        }}
      >
        <InputBase
          placeholder={translate("app.search")}
          onChangeText={(txt: string) => setInputSearchParkingList(txt)}
          value={inputSearchParkingList}
          icon={faCharCodes.faEdit}
        />
        {/* === Random Select === */}
        <TouchableHighlight
          onPress={() => {
            setReserveData({ ...reserveData, parkingLotId: null }),
              setIsModalVisible(false);
            setSelectParkingLot(null);
          }}
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          style={{
            padding: 10,
            height: 45,
            minWidth: 100,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: Theme.COLORS.BACKGROUND,
            borderRadius: 5,
            marginHorizontal: 5,

            shadowColor: Theme.COLORS.BACKGROUND,
            shadowOffset: {
              width: 0,
              height: 3,
            },
            shadowOpacity: 0.3,
            shadowRadius: 5.5,
            elevation: 9,
          }}
        >
          <Text style={{ color: Theme.COLORS.BLACK }}>
            {translate("app.randomSelect")}
          </Text>
        </TouchableHighlight>
      </View>
      {/* === Parking lot List === */}
      <ScrollView
        style={{
          flex: 1,
          borderRadius: 15,
          padding: 15,
          backgroundColor: Theme.COLORS.LIGHT_MAIN,
        }}
      >
        {availableLotsList.length !== 0 ? (
          filterParkingLotList.map((item: ParkingLot) => {
            return (
              <TouchableHighlight
                key={item.id}
                onPress={() => {
                  setReserveData({ ...reserveData, parkingLotId: item.id }),
                    setIsModalVisible(true);
                  setSelectParkingLot(item.name);
                }}
                underlayColor={Theme.COLORS.LIGHT_MAIN}
                style={{
                  padding: 10,
                  height: 45,
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: Theme.COLORS.PRIMARY,
                  marginBottom: 8,
                  borderRadius: 5,

                  shadowColor: Theme.COLORS.PRIMARY,
                  shadowOffset: {
                    width: 0,
                    height: 3,
                  },
                  shadowOpacity: 0.3,
                  shadowRadius: 5.5,
                  elevation: 9,
                }}
              >
                <View
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Text style={{ color: Theme.COLORS.WHITE }}>
                    {translate("smartParking.parkingName")} : {item.name}
                  </Text>
                </View>
              </TouchableHighlight>
            );
          })
        ) : (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <Text style={{ textAlign: "center" }}>
              {translate("app.emptyList")}
            </Text>
          </View>
        )}
      </ScrollView>
      {/* === modal form submit === === */}
      <ModalBase
        isOpen={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        contentStyle={{ height: "100%" }}
      >
        {/* === input Search == */}
        <View style={{ padding: 10, flex: 1 }}>
          <CheckInfoCard />
          <View style={{ marginTop: 10 }}>
            <TouchableHighlight
              style={[styles.btn, { marginTop: 10 }]}
              underlayColor={Theme.COLORS.THIRED}
              onPress={() => {
                const data = {
                  ...reserveData,
                  startTime: `${reserveData.startTime}`,
                  endTime: `${reserveData.endTime}`,
                };
                newReserveRequest(serverUrl, accessToken, data);
                setIsLoading(true);
                setIsModalVisible(false);
              }}
            >
              <Text style={{ color: Theme.COLORS.WHITE, fontWeight: "bold" }}>
                {translate("app.reserve")}
              </Text>
            </TouchableHighlight>
            <TouchableHighlight
              style={[
                styles.btn,
                {
                  marginTop: 10,
                  backgroundColor: Theme.COLORS.MUTED,
                  shadowColor: Theme.COLORS.MUTED,
                },
              ]}
              underlayColor={Theme.COLORS.GRAY_DARK}
              onPress={() => {
                setIsModalVisible(false);
              }}
            >
              <Text style={{ color: Theme.COLORS.BLOCK, fontWeight: "bold" }}>
                {translate("app.cancel")}
              </Text>
            </TouchableHighlight>
          </View>
        </View>
      </ModalBase>
    </View>
  ) : // === Confirm Message ===
  showConfirmMessage ? (
    <View style={{ flex: 1, padding: 10, justifyContent: "space-between" }}>
      <View style={[styles.container, { marginBottom: 10 }]}>
        <CheckInfoCard />
        {/* === Description card === */}
        {resultReserveMessage.length === 0 && reserveStatus && (
          <View
            style={[
              styles.errorContainer,
              ,
              {
                backgroundColor: "#e789305c",
                shadowColor: "#e78930",
                borderColor: "#e78930",
                borderWidth: 1,
                alignItems: "baseline",
                marginBottom: 12,
              },
            ]}
          >
            <FontAwesomeIcon
              style={{ marginHorizontal: 8 }}
              // icon={faCharCodes.faTimes}
              icon={faCharCodes.faInfoCircle}
              size={24}
              color={Theme.COLORS.BLACK}
            />
            <Text style={[styles.txt, { marginHorizontal: 8 }]}>
              {translate("smartParking.reservation.descriptionReserve")}
            </Text>
          </View>
        )}
        {/* === Message Container === */}
        <View>
          {resultReserveMessage.length == 0 ? (
            <View
              style={[
                styles.errorContainer,
                ,
                {
                  backgroundColor: "#03a158",
                  shadowColor: "#03a158",
                  alignItems: "center",
                },
              ]}
            >
              <FontAwesomeIcon
                style={{ marginHorizontal: 5 }}
                // icon={faCharCodes.faTimes}
                icon={faCharCodes.faCheck}
                size={20}
                color={Theme.COLORS.WHITE}
              />
              <Text style={[styles.txtLight, { textAlign: "justify" }]}>
                {translate(
                  "smartParking.resultMessage.ReservationSuccessfully"
                )}
              </Text>
            </View>
          ) : (
            <View
              style={[
                styles.errorContainer,
                { backgroundColor: "#d82f53", shadowColor: "#d82f53" },
                checkJustFailedToSmsError && {
                  backgroundColor: "#e789305c",
                  shadowColor: "#e78930",
                  borderColor: "#e78930",
                  borderWidth: 1,
                },
              ]}
            >
              <FontAwesomeIcon
                style={{ marginHorizontal: 5 }}
                icon={
                  checkJustFailedToSmsError
                    ? faCharCodes.faInfoCircle
                    : faCharCodes.faTimes
                }
                size={22}
                color={
                  checkJustFailedToSmsError
                    ? Theme.COLORS.BLACK
                    : Theme.COLORS.WHITE
                }
              />
              <View style={{ flexDirection: "column", alignItems: "center" }}>
                {checkJustFailedToSmsError &&
                  resultReserveMessage.length == 1 && (
                    <Text style={[styles.txt, { marginHorizontal: 8 }]}>
                      {translate("smartParking.resultMessage.reservationOk")}
                    </Text>
                  )}
                {resultReserveMessage.map((text) => {
                  return (
                    <Text
                      style={[
                        { marginHorizontal: 8 },
                        checkJustFailedToSmsError
                          ? styles.txt
                          : styles.txtLight,
                      ]}
                    >
                      {translate(`smartParking.resultMessage.${text}`)}
                    </Text>
                  );
                })}
                {messageResendSms !== "" && (
                  <View
                    style={[
                      styles.errorContainer,
                      {
                        backgroundColor: "#d82f53",
                        shadowColor: "#d82f53",
                        width: "100%",
                        marginVertical: 5,
                      },
                      messageResendSms == translate("app.successResendSms") && {
                        backgroundColor: "#03a158",
                        shadowColor: "#03a158",
                      },
                    ]}
                  >
                    <Text
                      style={{ color: Theme.COLORS.WHITE, textAlign: "center" }}
                    >
                      {messageResendSms}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          )}
        </View>
      </View>
      <View style={{}}>
        {(resultReserveMessage.length == 0 && reserveStatus) ||
          (resultReserveMessage.includes("FailedToSendSms") &&
            resultReserveMessage.length == 1 && (
              <TouchableHighlight
                style={[styles.btn, { marginTop: 10, width: "100%" }]}
                underlayColor={Theme.COLORS.THIRED}
                onPress={() => {
                  setShowParingLotsList(false);
                  setShowConfirmationMessage(false);
                  setReserveData({
                    phoneNumber: "",
                    date: new Date().toISOString(), // "2022-08-28T12:51:41.804Z"
                    startTime: "",
                    endTime: "",
                    buildingId: props.appReducer.currentBuilding.buildingId,
                    smartParkingId: parkingArea.smartParkingId,
                    parkingAreaId: parkingArea.id,
                    parkingLotId: reservedData?.parkingLotId || null,
                    fullName: "",
                    // scenarioId: null,
                  });
                }}
              >
                <Text style={{ color: Theme.COLORS.WHITE, fontWeight: "bold" }}>
                  {translate("smartParking.reservation.newReserve")}
                </Text>
              </TouchableHighlight>
            ))}
        {hideResendSms && (
          <TouchableHighlight
            style={[
              styles.btn,
              { marginTop: 10, backgroundColor: Theme.COLORS.MUTED },
              //  resultReserveMessage.length === 0 ? { width: "48%" } : { width: "100%" }
            ]}
            underlayColor={Theme.COLORS.THIRED}
            // onPress={() => props.navigation.goBack()}
            onPress={() => {
              resultReserveMessage.includes("FailedToSendSms") &&
              resultReserveMessage.length == 1
                ? setShowModalResendSms(true)
                : setShowConfirmationMessage(false);
            }}
          >
            <Text style={{ color: Theme.COLORS.WHITE, fontWeight: "bold" }}>
              {resultReserveMessage.includes("FailedToSendSms") &&
              resultReserveMessage.length == 1
                ? translate("app.sendSms")
                : translate("app.tryAgain")}
            </Text>
          </TouchableHighlight>
        )}
      </View>
      {/* === Resend Sms Modal === */}
      <AlertDialogBase
        isOpen={showModalResendSms}
        confirmText={translate("app.sendSms")}
        confirmHandler={() => {
          reserveId !== "" && resendSmsHandler(reserveId);
        }}
        onClose={() => setShowModalResendSms(false)}
      >
        <Text>{translate("smartParking.resendSms")}</Text>
      </AlertDialogBase>
    </View>
  ) : (
    // ===Form Add ==
    <View style={{ flex: 1, padding: 10, paddingBottom: 0 }}>
      <ScrollView style={{ padding: 5, marginBottom: 5 }}>
        {/* === FullName === */}
        <View style={{ marginBottom: 15 }}>
          <InputBase
            isInvalid={errorFullName !== ""}
            errorMessage={errorFullName}
            placeholder={translate("smartParking.reservation.fullNameGuest")}
            label={translate("smartParking.reservation.fullNameGuest")}
            onChangeText={(txt: string) =>
              setReserveData({ ...reserveData, fullName: txt })
            }
            value={reserveData.fullName}
            icon={faCharCodes.faEdit}
          />
          {/* {errorFullName !== "" && (
              <Text style={styles.textErr}>{errorFullName}</Text>
            )} */}
        </View>
        {/* === Phone Number === */}
        <View style={{ marginBottom: 15 }}>
          <InputBase
            isInvalid={errorFullName !== ""}
            errorMessage={errorFullName}
            placeholder={"0912345..."}
            label={translate("smartParking.reservation.phoneNumber")}
            onChangeText={(txt: string) =>
              setReserveData({ ...reserveData, phoneNumber: txt })
            }
            value={reserveData.phoneNumber}
            icon={faCharCodes.faEdit}
          />
        </View>
        {/* === Date Cale === */}
        <View style={{ marginBottom: 10 }}>
          <Text style={{ marginBottom: 8 }}>
            {translate("reservation.dateReserve")} : {dateJalaali}
          </Text>
          <Text style={{ color: Theme.COLORS.WARNING, marginBottom: 15 }}>
            {translate("smartParking.defaultDate")}
          </Text>
          <PersianCalendar
            minDate={new Date()}
            onDateChange={(text) => {
              setReserveData({
                ...reserveData,
                date: new Date(text._d).toISOString(),
              });
              setDatejalaali(moment(text._d).format("jYYYY/jM/jD"));
            }}
          />
        </View>
        {/* === Time Picker === */}
        <View style={styles.container}>
          <View
            style={{
              height: 50,
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <Text style={{ width: 100 }}>
              {translate("reservation.startTime")} :{" "}
            </Text>
            <SimpleTimePicker
              placeholderHour={`${nowTimeHour}`}
              placeholderMin={`${nowTimeMin}`}
              value={reserveData.startTime}
              onChange={(time: string) => {
                setReserveData({ ...reserveData, startTime: time });
              }}
            />
          </View>
          <View
            style={{ height: 50, flexDirection: "row", alignItems: "center" }}
          >
            <Text style={{ width: 100 }}>
              {translate("reservation.endTime")} :{" "}
            </Text>
            <SimpleTimePicker
              placeholderHour={`${twoHourNowTime}`}
              placeholderMin={`${nowTimeMin}`}
              value={reserveData.endTime}
              onChange={(time: string) => {
                setReserveData({ ...reserveData, endTime: time });
              }}
            />
          </View>
        </View>
        {errorMessageTimer !== "" && (
          <Text style={styles.textErr}>{errorMessageTimer}</Text>
        )}
        {/* === Submit Form === */}
        <TouchableHighlight
          style={[styles.btn, { marginTop: 10 }]}
          underlayColor={Theme.COLORS.THIRED}
          onPress={() => {
            if (reserveData.fullName == "") {
              setErrorFullName(
                translate("smartParking.errors.pleaseEnterGuestName")
              );
            } else {
              setErrorFullName("");
            }
            if (
              reserveData.phoneNumber.length < 11 ||
              reserveData.phoneNumber.length > 11
            ) {
              setErrorMessagePhone(
                translate("smartParking.errors.pleaseEnterValidContactNumber")
              );
            } else {
              setErrorMessagePhone("");
            }

            if (accessTime() === false) {
              setErrorMessageTimer(translate("reservation.errorConflictTime"));
            } else {
              setErrorMessageTimer("");
            }

            // === available lots req ===
            if (
              reserveData.fullName !== "" &&
              // reserveData.phoneNumber !== "" &&
              reserveData.phoneNumber.length == 11 &&
              // errorMessageTimer == "" &&
              // reserveData.endTime !== "" &&
              // reserveData.startTime !== "" &&
              accessTime() &&
              !showParkingLotsList
            ) {
              setIsLoading(true);
              getAvailableLotsRequest(serverUrl, accessToken);
            }
          }}
        >
          <Text style={{ color: Theme.COLORS.WHITE, fontWeight: "bold" }}>
            {showParkingLotsList
              ? props.navigation.state.params.editMode
                ? translate("app.applyChanges")
                : translate("app.reserve")
              : translate("app.nextStep")}
          </Text>
        </TouchableHighlight>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
    borderRadius: 10,
    marginBottom: 12,
    padding: 10,
    paddingHorizontal: 12,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  selectContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 85,
  },
  btn: {
    // flex: 1,
    paddingVertical: 15,
    paddingHorizontal: 18,
    // width: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.PRIMARY,
    borderRadius: 5,
    minWidth: 130,

    shadowColor: Theme.COLORS.PRIMARY,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  textErr: {
    color: Theme.COLORS.ERROR,
  },
  txt: {
    fontSize: 15,
    color: Theme.COLORS.BLACK,
    marginVertical: 10,
  },
  txtLight: {
    fontSize: 15,
    color: Theme.COLORS.WHITE,
    marginVertical: 10,
  },
  errorContainer: {
    // flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
    padding: 10,
    borderRadius: 10,

    // alignItems: "center"
  },
});

const mapStateToProps = (state: any) => {
  return {
    reducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     removeScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.Remove(scenarioId, accessToken)),
//     runScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.RunScenario(scenarioId, accessToken)),
//     toggleEnable: (scenarioId, enable, accessToken) =>
//       dispatch(Actions.ToggleEnable(scenarioId, enable, accessToken)),
//     getDetails: (scenarioId, accessToken) =>
//       dispatch(Actions.GetDetails(scenarioId, accessToken)),
//   };
// };
ParkingReservationFormScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.ParkingReservation"),
});
export default connect(
  mapStateToProps,
  null
)(React.memo(ParkingReservationFormScreen));
